import { isAnyOf } from "@reduxjs/toolkit";
import {
  allStatusFulfilledMatchers,
  allStatusPendingMatchers,
  allStatusRejectedMatchers,
  statusApi,
} from "../../api/statusApi";
import {
  createGenericState,
  onFulfilledMatcher,
  onPendingMatcher,
  onRejectMatcher,
} from "../genericState/genericState";
import { OnboardingState } from "../onboarding/onboarding.slice";

const initialState: OnboardingState = {
  isLoading: false,
  isError: false,
  isSuccess: false,
  isUninitialized: true,
  error: undefined,
  data: undefined,
  currentStep: 0,
};

export const statusSlice = createGenericState("@Status", initialState, {
  extraReducers: builder => {
    builder
      .addMatcher(
        statusApi.endpoints.statusNext.matchPending,
        (state, action) => {
          state.stepValues = action.meta.arg.originalArgs.values;
        },
      )
      .addMatcher(isAnyOf(...allStatusPendingMatchers), (state, action) => {
        return onPendingMatcher(state, action);
      })
      .addMatcher(isAnyOf(...allStatusRejectedMatchers), (state, action) => {
        onRejectMatcher(state, action);
      })
      .addMatcher(isAnyOf(...allStatusFulfilledMatchers), (state, action) => {
        onFulfilledMatcher(state, action);
      });
  },
});

export const statusActions = {
  ...statusSlice.actions,
};
export default statusSlice;
